// extracted by mini-css-extract-plugin
export default {"mainContent":"layout_mainContent__TMiYO","pageContent":"layout_pageContent__mGp7t"};